export enum OrderReturnStatusTypes {
    OPEN = "open",
    CANCELED = "canceled",
    IN_PROCESS = "in_process",
    PARTIALLY_COMPLETED = "partially_completed",
    COMPLETED = "completed",
}

export type OrderReturnStatusType =
    | OrderReturnStatusTypes.OPEN
    | OrderReturnStatusTypes.IN_PROCESS
    | OrderReturnStatusTypes.CANCELED
    | OrderReturnStatusTypes.PARTIALLY_COMPLETED
    | OrderReturnStatusTypes.COMPLETED;

export interface OrderReturnStatus {
    /* Process status type */
    type: OrderReturnStatusType;
    /* Localized status message */
    text: string;
}

export interface OrderReturnItem {
    /* Unique identifier of the return entry */
    returnNumber: string;
    /* Current process status */
    status: OrderReturnStatus;
    /* Date when the return process was created */
    createdAt: string;
    /* Who did create the return process */
    createdBy: string;
    /* Number of positions included in the return */
    positions: number;
    /* URL of the order return detail page */
    detailLink: string;
}

export interface OrderReturnResponse {
    /* API endpoint form requesting further results */
    nextPage?: string | null;
    /* The total number of results */
    totalCount: number;
    /* The number of results with current filter applied */
    filteredCount: number;
    /* Markup for the filters */
    filterHTML?: string | null;
    /* The result items */
    items: OrderReturnItem[];
}
